// extracted by mini-css-extract-plugin
export default {"cls1":"VeloModalSheetFooter_cls1__9yH45","cls2":"VeloModalSheetFooter_cls2__P8vDk VeloModalSheetFooter_cls1__9yH45"};